import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import { Icon } from 'gestalt';
import { instance as pubSub } from 'app/common/lib/PubSub';

const CLOSE_BUTTON_STYLE = {
  backgroundColor: 'transparent',
  border: 0,
  right: 80,
};

export class BottomBanner extends Component {
  // TODO (briantran): Consider putting BottomBanner into a type (either TOAST
  // or a new one)
  // TODO (briantran): Add context logging
  // TODO (briantran): Hide overlapping footer buttons
  static propTypes = {
    bannerText: PropTypes.string.isRequired,
    canClose: PropTypes.bool,
    handleComplete: PropTypes.func,
    transitionEvent: PropTypes.number,
  };

  static defaultProps = {
    canClose: false,
  };

  constructor(props, context) {
    super(props, context);
    const { handleComplete, transitionEvent } = props;

    // clear on navigation event by default
    const completeEvents = [
      PCONST.PUBSUB_TOPIC_NAVIGATE_STARTED,
      ...(transitionEvent ? [transitionEvent] : []),
    ];
    this.subscribers = completeEvents.map((completeEvent) =>
      pubSub.subscribe(PCONST.PUBSUB_CHANNEL_SITE, completeEvent, handleComplete),
    );
  }

  componentWillUnmount() {
    this.subscribers.forEach((subscriber) => subscriber.unsubscribe());
    this.subscribers = [];
  }

  subscribers = [];

  render() {
    const { bannerText, canClose, handleComplete } = this.props;

    // TODO (luna): support affinity NUX use of the banners
    return (
      <div className="Module BottomBanner">
        <div className="bannerContainer">
          <div className="bannerText">
            {/* eslint-disable  react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: bannerText }} />
            {/* eslint-enable  react/no-danger */}
          </div>
          {canClose && (
            <button
              className="absolute closeButton p0"
              onClick={handleComplete}
              style={CLOSE_BUTTON_STYLE}
            >
              <Icon
                accessibilityLabel={i18n._('close', 'Accessible label for the banner close button')}
                color="white"
                icon="cancel"
                inline
              />
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default BottomBanner;
